import React from "react";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { OperationCompletedPanel } from "../layout/OperationCompletedPanel";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { navigate } from "../../redux/feature/general/navigation-slice";
import { DOCUMENTS_LISTS } from "../../utils/constants/navigation";
import { useAppDispatch } from "../../redux/hooks/hooks";

export const DocumentNotValidError = () => {
  const dispatch = useAppDispatch();
  return (
    <OperationCompletedPanel
      message={formatMessage("cof.opendocuments.message.warning.notcofdocument")}
      alt={formatMessage("cof.opendocuments.message.warning.notcofdocument")}
      icon="/assets/illustrations/oopsNotTagetik.svg"
      styles={{ container: { minHeight: "70vh" } }}
    >
      <PrimaryButton
        text={formatMessage("cof.opendocuments.opendocument")}
        onClick={() => dispatch(navigate(DOCUMENTS_LISTS))}
      />
    </OperationCompletedPanel>
  );
};
